import api from './api'

const getSchools = (params) => api.get(`/EscolaINEP`, { params })

const getCitiesByUF = (uf) => api.get(`/EscolaINEP/cidades/${uf}`)

const getYears = () => api.get('/Ano')

export const SchoolsService = {
  getSchools,
  getCitiesByUF,
  getYears,
}
